import { SGeneralForms, SLocalTreeSelected } from 'shj-components'
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import { Select, TreeSelect } from 'antd'
import { trimStr } from '@/utils/data.ts'
import DebounceSearchSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import { getSubItemManagementPage } from '@/services/product.ts'
import { useSetState } from 'ahooks'
import { getChildrenDicts } from '@/services'
import { cloneDeep } from 'lodash-es'
import _ from 'lodash'

type IProps = {
  fn: () => void
  setSubmitLoading: (v: boolean) => void
  spaceList: any[]
  record: any
  companyList: any[]
  dataSource: any[]
}

export const AddOrEditChild = forwardRef((props: IProps, ref) => {
  const { record, companyList, dataSource = [] } = props
  const [state, setState] = useSetState<any>({
    roleList: [],
    copyDisabled: false,
    selectedRoleList: [],
  })

  const formRef = useRef()
  const [optionList, setOptionList] = useState([{ id: '0', name: '通用' }, ...companyList])

  useEffect(() => {
    onFormRef()?.resetFields()
    onFormRef()?.setFieldsValue({
      ...record,
      parentId: record.parentId == 0 ? null : record.parentId,
      shops: record.shops,
    })
    shopsControl(record.shops)
  }, [record])

  const spaceList = useMemo((): any[] => {
    if (record.spaceTag && props.spaceList) {
      return (
        props.spaceList?.map(item => {
          const item_ = { ...item }
          if (item.priKey === record.spaceTag) {
            item_.disabled = false
          }
          return item_
        }) || []
      )
    }
    return props.spaceList || []
  }, [props.spaceList, record])

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const dealTree = (data, res = []) => {
    data.forEach(item => {
      if (item.busType === 'PRD_CATE') {
        res.push(item)
        if (item.children?.length) {
          item.children = dealTree(item.children)
        }
      }
    })
    return res
  }

  const tree = useMemo(() => {
    return dealTree(cloneDeep(dataSource))
  }, [dataSource])

  const getShopArr = codeArr => {
    return optionList?.reduce((res, item) => {
      if (codeArr.includes(item.id)) res.push({ id: item.id, companyName: item.name })
      return res
    }, [])
  }
  const shopsControl = (value: any) => {
    let newOption: any = _.cloneDeep(optionList)
    if (value?.length) {
      if (value.includes('0')) {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id !== '0',
          }
        })
      } else {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id === '0',
          }
        })
      }
    } else {
      newOption = newOption.map((item: any) => {
        return {
          ...item,
          disabled: false,
        }
      })
    }
    setOptionList(newOption)
  }
  const onFinish = () => {
    return new Promise((resolve, reject) => {
      onFormRef()
        ?.validateFields()
        .then(values => {
          props.setSubmitLoading?.(true)
          const shopList = values.shops ? getShopArr(values.shops) : []
          resolve({
            ...values,
            id: record.id,
            parentId: values.parentId,
            oldParentId: record.parentId || '0',
            level: record.level || 0,
            shopList: shopList,
            shops: values.shops,
            busType: 'PRD_SUB_ITEM',
            busTypeName: '子项',
            busId: values.busId,
          })
          resolve(values)
        })
    })
  }
  useImperativeHandle(ref, () => {
    return {
      onFinish,
    }
  }, [onFinish])

  return (
    <>
      <SGeneralForms
        ref={formRef}
        isHideGobackBtn={true}
        layout="vertical"
        titleMode={'edit'}
        initialValues={{ isCopy: true, isShowOrder: true, isMust: true }}
        configs={[
          {
            title: '基础信息',
            formItem: [
              {
                name: 'parentId',
                label: '所属分类',
                spanCol: 24,
                children: (
                  <TreeSelect
                    treeData={tree}
                    placeholder={'请选择上级分类'}
                    fieldNames={{ label: 'name', value: 'id' }}
                    treeTitleRender={node => node?.dtlName}
                  />
                ),
              },
              {
                name: 'busId',
                label: '子项',
                required: true,
                rules: [{ required: true, message: '子项不能为空' }],
                spanCol: 24,
                children: (
                  <DebounceSearchSelect
                    label={'子项'}
                    nameKey={'itemNameKeyword'}
                    query={{ id: record.busId }}
                    onChange={(v, o) => o && onFormRef()?.setFieldValue('dtlName', o.label)}
                    fetchOptions={getSubItemManagementPage}
                    fieldNames={{ label: 'itemName' }}
                  />
                ),
              },
              {
                name: 'dtlName',
                label: '显示名称',
                required: true,
                rules: [{ required: true, message: '显示名称不能为空' }],
                spanCol: 24,
                comConfig: {
                  showCount: true,
                  maxLength: 15,
                  onChange: e => onFormRef()?.setFieldValue('dtlName', trimStr(e.target.value)),
                },
              },
            ],
          },
          {
            title: '打包配置',
            formItem: [
              {
                name: 'isMust',
                label: '是否必选',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
              /*{
                name: 'spaceTag',
                label: '空间标签',
                children: (
                  <Select
                    placeholder={'请选择空间标签'}
                    allowClear
                    showSearch
                    optionFilterProp={'children'}
                    onChange={v => {
                      setState({ copyDisabled: !!v })
                      if (v) {
                        onFormRef()?.setFieldValue('isCopy', true)
                      }
                    }}
                  >
                    {spaceList?.map(item => (
                      <Select.Option disabled={item.disabled} value={item.priKey}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                ),
                spanCol: 24,
              },
              {
                name: 'isCopy',
                label: '是否允许复制',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  // disabled: state.copyDisabled,
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },*/
            ],
          },
          {
            title: '显示配置',
            formItem: [
              {
                name: 'isShowOrder',
                label: '下单时是否显示',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
            ],
          },
          {
            title: '适用渠道',
            formItem: [
              {
                name: 'shops',
                label: '适用门店',
                spanCol: 24,
                children: (
                  <Select
                    optionFilterProp={'name'}
                    placeholder={'请选择适用门店'}
                    mode={'multiple'}
                    fieldNames={{ label: 'name', value: 'id' }}
                    onChange={(value, option) => {
                      shopsControl(value)
                    }}
                    options={optionList}
                  />
                ),
              },
            ],
          },
        ]}
      />
    </>
  )
})
